import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { AddToProductComponent } from 'src/app/folder/add-to-product/add-to-product.component';
import { setLoading } from 'src/app/redux/actions/user.actions';
import { AppState } from 'src/app/redux/app.state';
import { NotificationService } from 'src/app/services/notification.service';
import { Folder, Product } from 'src/typings';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-product-folders',
  templateUrl: './folders.component.html',
  styleUrls: ['./folders.component.scss']
})
export class FoldersComponent {
  @Input() set product(payload: Product | undefined) {
    this._product = payload;
    if (payload && payload.folders) {
      this.folders = payload.folders;
    }
    if (payload && !payload.folders) {
      this.loadFolders(payload);
    }
  }

  async loadFolders(product: Product) {
    const prod = await this.productService.getOne(product.id).toPromise();
    this.product = prod;
  }

  set loading(value: boolean) {
    this.store.dispatch(setLoading({ payload: value }));
  }

  get product() {
    return this._product;
  }

  private _product: Product | undefined;

  folders: Folder[] = [];

  columnsToDisplay = ['folder', 'menu'];

  constructor(
    private dialog: MatDialog,
    private productService: ProductService,
    private notificationService: NotificationService,
    private store: Store<AppState>
  ) {}

  addFolder() {
    const dialogRef = this.dialog.open(AddToProductComponent);
    dialogRef.componentInstance.product = this.product;
    dialogRef.componentInstance.doneEvent.subscribe((product) => {
      dialogRef.close();
      this.product = product;
    });
  }

  async removeFolder(id: number) {
    if (!this.product) return this.notificationService.warning('Нет товара!');
    const confirm = window.confirm('Убрать товар с папки?');
    if (!confirm) return;
    this.loading = true;
    try {
      const newProduct = await firstValueFrom(
        this.productService.removeFolder({
          product_id: this.product?.id,
          folder_id: id
        })
      );
      this.product = newProduct;
    } catch (err) {
      console.error(err);
    }
    this.loading = false;
    return;
  }
}
